import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { about_img1, about_img2, about_img3, we_do1, we_do2 } from "../../constants";
import "../../assets/css/about.css";

const About = () => {
  return (
    <>
      {/* Header starts here */}
      <Header />
      {/* Header ends here */}
      {/* About pageHeader starts here */}
      <section className="about_pageheader">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="pageheader-content-wrapper">
                <h2>About Apricot</h2>
                <h5>BE PART OF THE CHANGE</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About pageHeader ends here */}
      {/* About section starts here */}
      <section className="about-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper pe-5">
                <h3>Our Mission</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Turpis egestas sed tempus urna et pharetra. Faucibus purus in
                  massa tempor nec feugiat. Aliquet bibendum enim facilisis
                  gravida neque convallis. Vel quam ele
                </p>
                <a href="#" className="btn">
                  Contact us
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-wrapper">
                <figure>
                  <img src={about_img1} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
          </div>
          <div className="row align-items-center pt-5 mt-5">
            <div className="col-lg-7">
              <div className="row">
                <div className="col-lg-6">
                  <div className="img-wrapper">
                    <figure>
                      <img src={about_img2} className="img-fluid" alt="" />
                    </figure>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="img-wrapper mt-5 pt-5">
                    <figure>
                      <img src={about_img3} className="img-fluid" alt="" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="content-wrapper ps-5">
                <h3>Our Vision</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Turpis egestas sed tempus urna et pharetra. Faucibus purus in
                  massa tempor nec feugiat. Aliquet bibendum enim facilisis
                  gravida neque convallis. Vel quam ele
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About section ends here */}
      {/* we do sec starts here */}
      <section className="we-do">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-12">
              <div className="content-wrapper text-center">
                <h2 className="sec-heading">What we Do</h2>
              </div>
            </div>
          </div>
          <div className="we-color-wrapper row align-items-center">
            <div className="col-lg-6">
              <div className="img-wrapper">
                <figure>
                  <img src={we_do1} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content-wrapper">
                <div className="headings-wrapper">
                  <h2>Our History</h2>
                  <h1>2005 - 2015</h1>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Turpis egestas sed tempus urna et pharetra. Faucibus purus in
                  massa tempor nec feugiat. Aliquet bibendum enim facilisis
                  gravida
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="content-wrapper">
                <div className="headings-wrapper">
                  <h2>Our History</h2>
                  <h1>2015 - 2022</h1>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Turpis egestas sed tempus urna et pharetra. Faucibus purus in
                  massa tempor nec feugiat. Aliquet bibendum enim facilisis
                  gravida
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-wrapper">
                <figure>
                  <img src={we_do2} className="img-fluid" alt="" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* we do sec ends here */}
      {/* Footer starts here */}
      <Footer />
      {/* Footer ends here */}
    </>
  );
};

export default About;
